import cn from 'clsx';
import { FC, ReactNode } from 'react';

import s from './Contents.module.scss';

export interface ContentsProps {
  children: ReactNode;
  isBottomButton?: boolean;
  className?: string;
}

const Contents: FC<React.PropsWithChildren<React.PropsWithChildren<ContentsProps>>> = ({ children, isBottomButton = false, className }) => {
  return (
    <div className={cn(s.content, { [s.bottom_button_padding as string]: isBottomButton }, className)}>
      {children}
      {isBottomButton && <br />}
    </div>
  );
};

export default Contents;
